type RecursiveObject<T> = T extends Date ? never : T extends Record<string, any> ? T : never;

// Extends all values of interface with given type, default is string
export type ExtendType<TModel, E = string> = {
  [Key in keyof TModel]: TModel[Key] extends RecursiveObject<TModel[Key]> ? ExtendType<TModel[Key]> : E;
};
